import { yupResolver } from "@hookform/resolvers/yup";
import { get } from "lodash";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import api from "../../apis/axiosInterceptor";
import { Button, TextBox } from "../../components";
import Layout, { Breadcrumb, Container } from "../../components/layout";
import { useAppState } from "../../context";
// import { encryptPass } from "../../shared/functions";
import toast from "react-hot-toast";
import allImgPaths from "../../assets";
import { profileValidation } from "../../validations";

// interface ImageState {
//   preview: string;
//   data: string | File;
// }

const Profile = () => {
  const { memberId } = useAppState("auth");
  const [userImage, setUserImage] = useState(allImgPaths.defaultImage);

  // const [image] = useState<ImageState>({ preview: "", data: "" });
  // const [, setImgPreview] = useState<any | null>(null);
  const [memberData, setMemberData] = useState<any>({});
  const [imageFileName, setImageFileName] = useState<any>("");
  const [status, setStatus] = useState(false);
  const [lMemberId, setLMemberId] = useState("");
  const [previewPdf, setPreviewPdf] = useState(false);
  const { updateState } = useAppState("auth");
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  const {
    handleSubmit,
    setValue,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      profile: "",
      memberName: "",
      mobileNo: "",
      companyName: "",
      classification: "",
      childrenName: "",
      spouseName: "",
      accomplishments: "",
      referrals: "",
      goals: "",
      interests: "",
      network: "",
      skills: "",
      success: "",
      desires: "",
      clients: "",
    },
    mode: "all",
    reValidateMode: "onChange",
    resolver: yupResolver(profileValidation),
  });

  const fetchUserProfileData = async (id: any) => {
    try {
      const {
        data: { data },
        status,
      } = await api.get(`/api/members/${id}`);

      if (status === 200) {
        setMemberData(data);
        setValue("memberName", get(data, "memberName", ""));
        setValue("mobileNo", get(data, "mobileNo", ""));
        setValue("companyName", get(data, "companyName", ""));
        setValue("classification", get(data, "classification", ""));
        setValue("childrenName", get(data, "childrenName", ""));
        setValue("spouseName", get(data, "spouseName", ""));
        setValue("accomplishments", get(data, "accomplishments", ""));
        setValue("referrals", get(data, "referrals", ""));
        setValue("goals", get(data, "goals", ""));
        setValue("interests", get(data, "interests", ""));
        setValue("network", get(data, "network", ""));
        setValue("skills", get(data, "skills", ""));
        setValue("success", get(data, "success", ""));
        setValue("desires", get(data, "desires", ""));
        setValue("clients", get(data, "clients", ""));
        // setValue("password", "xxxxx@xxx");
        const profileImage = get(data, "profile", "");
        setImageFileName(profileImage);
        const fullImageUrl = profileImage
          ? `${process.env.REACT_APP_API_URL}/api/members/profileImage/${profileImage}`
          : allImgPaths.defaultImage;

        setUserImage(fullImageUrl);
        setValue("profile", fullImageUrl);

        // if (get(data, "profile_pic", "")) {
        //   setImgPreview(get(data, "profile_pic", ""));
        // } else {
        //   // setImgPreview(allImgPaths.user);
        // }
      }
    } catch (error) {
      // toast.error("Error while fetching user profile data");
      console.log("error => ", error);
    }
  };

  useEffect(() => {
    if (previewPdf) {
      const fetchPdf = async () => {
        try {
          const pdfUrl = `${process.env.REACT_APP_API_URL}/api/members/generate-pdf/?id=${lMemberId}`;
          window.open(pdfUrl, "_blank");
        } catch (error) {
          console.error("Error fetching PDF preview:", error);
          toast.error("Failed to preview PDF.");
        }
      };

      fetchPdf();
    }
  }, [previewPdf, lMemberId]);
  console.log("memberId => ", memberId);

  useEffect(() => {
    const memberIdFromStore: any = sessionStorage.getItem("memberId");
    setLMemberId(memberIdFromStore);
    fetchUserProfileData(memberIdFromStore);
  }, []);

  const onSubmit = async (mData: any) => {
    console.log("mData => ", mData);

    if (!imageFileName) {
      toast.error("Please upload a profile image before previewing.");
      return;
    }

    setIsLoading(true);
    try {
      const response = await api.put(`/api/members/${lMemberId}`, {
        ...mData,
        profile: imageFileName,
      });

      if (response.data.status === true) {
        toast.success("Profile updated successfully!");
        setStatus(true);
        setPreviewPdf(true);
      }
    } catch (error) {
      console.error("Error updating profile:", error);
      toast.error("Failed to update profile.");
    } finally {
      setIsLoading(false);
    }
  };

  const uploadProfilePic = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (!file) return;

    // Show immediate preview
    const localPreviewUrl = URL.createObjectURL(file);
    setUserImage(localPreviewUrl); // Preview now

    const formData = new FormData();
    formData.append("profile", file);

    try {
      const response = await api.post("api/members/profileImage", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const fileName = response.data?.data?.profile;
      setImageFileName(fileName);
      const fullImageUrl = `${process.env.REACT_APP_API_URL}/api/members/profileImage/${fileName}`;
      setUserImage(fullImageUrl);
      setValue("profile", fullImageUrl);
    } catch (err: any) {
      toast.error(
        err?.response?.data?.message ||
          "Image dimensions too large. Please upload an image with a minimum width of 800px and a minimum height of 800px.",
      );
      setUserImage(allImgPaths?.defaultImage);
      // console.error("Image upload error: ", err?.response?.data?.message);
    }
  };
  // const deleteProfilePic = () => {
  //   setUserImage("");
  // };
  const deleteProfilePic = async () => {
    try {
      // Send the request to delete the image from the server
      await api.post("api/members/profileImage", { profile: null });

      // Reset the local state and form value
      const defaultImg = allImgPaths.defaultImage;
      setUserImage(defaultImg);
      setImageFileName("");
      setValue("profile", "");

      toast.success("Profile picture deleted successfully.");
    } catch (error) {
      console.error("Failed to delete profile picture:", error);
      toast.error("Failed to delete profile picture.");
    }
  };

  const handleCancel = () => {
    updateState({ isLoggedIn: false });
    navigate("/login");
  };

  if (status) {
    return <Profile />;
  }

  return (
    <>
      {isLoading ? (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
          <div className="text-white text-lg flex flex-col items-center">
            <div className="flex justify-center">
              <img
                src={allImgPaths.bniLogoImg}
                width={100}
                height={100}
                alt="Logo"
              />
            </div>
            <p className="text-center">Generating your GAINS profile...</p>
          </div>
        </div>
      ) : (
        <Layout>
          <Breadcrumb title="" />
          <Container>
            <div className="px-5 sm:max-w-[80%] sm:mx-auto">
              <div className="flex items-center justify-between gap-6 my-3">
                <div className="flex items-start gap-6">
                  {/* Profile Image Section */}
                  <div className="relative md:w-32 md:h-32 w-28 h-28">
                    <img
                      src={userImage}
                      alt="Profile"
                      className="w-full h-full object-cover rounded-full border border-gray-300"
                    />

                    {/* Edit Icon */}
                    <label htmlFor="profilePic">
                      <div className="absolute bottom-0 right-0 bg-black rounded-full p-1 shadow cursor-pointer">
                        <img
                          src={allImgPaths.camera} // Replace with your actual icon path
                          alt="Edit"
                          className="md:h-5 md:w-5 h-4 w-4"
                        />
                      </div>
                    </label>

                    {/* Delete Icon */}
                    {userImage !== allImgPaths.defaultImage && (
                      <button
                        type="button"
                        onClick={deleteProfilePic}
                        className="absolute top-0 right-0 bg-black rounded-full p-1 shadow cursor-pointer"
                      >
                        <img
                          src={allImgPaths.deleteWhiteIcon} // Replace with your actual icon path
                          alt="Delete"
                          className="md:h-5 md:w-5 w-4 h-4"
                        />
                      </button>
                    )}

                    <input
                      type="file"
                      id="profilePic"
                      accept="image/*"
                      className="hidden"
                      onChange={uploadProfilePic}
                    />
                  </div>

                  {/* Member Info Grid Below Image */}
                  <div className="grid grid-cols-1 gap-1 mt-1 text-base text-gray-700">
                    <div>
                      <div className="md:text-base text-sm font-semibold text-gray-600">
                        {memberData.memberName}
                      </div>
                    </div>
                    <div>
                      <div className="md:text-base text-sm font-semibold text-gray-600">
                        {memberData.companyName}
                      </div>
                    </div>
                    <div>
                      <div className="md:text-base text-sm font-semibold text-gray-600">
                        {memberData.classification}
                      </div>
                    </div>
                    <div>
                      <div className="md:text-base text-sm font-semibold text-gray-600">
                        {memberData.mobileNo}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="">
                  <img
                    width={100}
                    height={100}
                    src={allImgPaths.bniLogoImg}
                    alt=""
                  />
                </div>
              </div>

              <div className="my-5">
                <hr className="border-[1px] border-[#cf202f]" />
              </div>
              <div className="container mx-auto">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        Spouse Name
                      </label>
                      <TextBox
                        name="spouseName"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        Goals
                      </label>
                      <TextBox
                        name="goals"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        Children Name
                      </label>
                      <TextBox
                        name="childrenName"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        Accomplishments
                      </label>
                      <TextBox
                        name="accomplishments"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        My Key to Success
                      </label>
                      <TextBox
                        name="success"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        Interests
                      </label>
                      <TextBox
                        name="interests"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        My Burning Desire
                      </label>
                      <TextBox
                        name="desires"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        Network
                      </label>
                      <TextBox
                        name="network"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        Ideal Referrals
                      </label>
                      <TextBox
                        name="referrals"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div>
                      <label className="block text-base font-semibold text-gray-600">
                        Skills
                      </label>
                      <TextBox
                        name="skills"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                    <div className="cols-span-1">
                      <label className="block text-base font-semibold text-gray-600">
                        Top 5 Clients
                      </label>
                      <TextBox
                        name="clients"
                        type="textarea"
                        control={control}
                        errors={errors}
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-center mt-10 gap-5">
                    <div>
                      <Button
                        variant="outlined"
                        className="btn-color !h-10 !text-base !px-4"
                        onClick={handleCancel}
                      >
                        Back
                      </Button>
                    </div>
                    <div>
                      <Button
                        variant="contained"
                        className="!h-10 !text-base !bg-[#e63737]"
                        type="submit"
                      >
                        Preview
                      </Button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Container>
        </Layout>
      )}
    </>
  );
};

export default Profile;
